import React from 'react';
import {
  Box,
  Button,
  DownloadIcon,
  Typography,
} from '@forgeglobal/design-framework';
import { AuthenticatedLink } from '@tcs/client-portal-common/components/molecules/AuthenticatedLink';
import { getConfig } from '@tcs/client-portal/config/configService';
import formatUrl from '@tcs/common/utils/formatUrl';
import { useStyles } from './DownloadActionCell.style';

interface DownloadActionCellProps {
  downloadUrl: string;
  reportName?: string;
}

const DownloadActionCell = ({
  downloadUrl,
  reportName,
}: DownloadActionCellProps) => {
  const classes = useStyles();
  const config = getConfig();

  const endpoint = `${formatUrl(
    config.API_BASE_URL
  )}/rss/generatedreports/download/${downloadUrl}`;

  return (
    <Box className={classes.container}>
      <AuthenticatedLink
        to={endpoint}
        url={endpoint}
        defaultFileName={reportName ?? 'report.xlsx'}
        openInNewTab={false}
        className={classes.downloadButton}>
        <Button
          variant="text"
          size="small"
          startIcon={<DownloadIcon className={classes.downloadIcon} />}>
          <Typography variant="body2">Download</Typography>
        </Button>
      </AuthenticatedLink>
    </Box>
  );
};

export default DownloadActionCell;
